import { FC } from 'react';
import { TimeButton } from 'shared/ui/buttons/iconButtons/timeButton/TimeButton';
import { useCurrentTime } from '../lib/hooks/useCurrentTime';

export const CurrentTimeSwitch: FC = () => {
	const { setCurrentTime, currentTimeText, isSelected, formattedTime } = useCurrentTime();

	return (
		<TimeButton text={formattedTime?.time || currentTimeText} selected={isSelected} onClick={setCurrentTime} />
	);
};
